"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = void 0;
const tslib_1 = require("tslib");
const NearDefinition = tslib_1.__importStar(require("./data/near"));
const NearTestnetDefinition = tslib_1.__importStar(require("./data/near-testnet"));
exports.chains = {
    aurora: NearDefinition,
    'aurora-testnet': NearTestnetDefinition,
    near: NearDefinition,
    'near-testnet': NearTestnetDefinition,
};
